import { useMemo } from 'react'
import createAPI, { TrainingAPI } from 'session-info/api/index'

const useTrainingAPI = (): TrainingAPI => useMemo(createAPI, [])

export default useTrainingAPI
